var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 3,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FEE4E2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 3,
    width: 32,
    height: 32,
    rx: 16,
    stroke: "#FEF3F2",
    strokeWidth: 5.33333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5002 16.3333V19M19.5002 21.6666H19.5068M26.1668 19C26.1668 22.6819 23.1821 25.6666 19.5002 25.6666C15.8183 25.6666 12.8335 22.6819 12.8335 19C12.8335 15.3181 15.8183 12.3333 19.5002 12.3333C23.1821 12.3333 26.1668 15.3181 26.1668 19Z",
    stroke: "#D92D20",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.ba3a5ab6f825595fb38a0809a72ddb6a.svg";
export { ForwardRef as ReactComponent };